export enum EMessageType {
    EMAIL = 1,
    WHATSAPP = 2
}

export enum EStudyInformStatus {
  SD_REQUESTED = 1,
  SD_INFORMED_PARTIAL = 2,
  SD_INFORMED_COMPLETE = 3,
  SD_VALIDATED = 4,
  SD_CANCELED = 5,
}